<template>
  <div class="cdata-edit-container">
    <!--{{field}}-->
<!--    {{getLabel}}-->
    <!--    {{fieldType}}-->
    <!--{{optionsCalced}}-->
    <!--{{dataValueRaw}}-->
    <editable-input v-if="['single_option', 'multiple_option'].includes(fieldType)"
                    type="select"
                    :context="context"
                    :update="updater" :name="fieldKey"
                    :options="optionsCalced"
                    :config="optionsConfig"
                    :label="getLabel"
                    :value="dataValue">
      <template #label>{{ getLabel }}</template>
    </editable-input>
    <!--<editable-input v-else-if="fieldType == 'multiple_option'"-->
    <!--                type="select"-->
    <!--                :context="context"-->
    <!--                :update="updater" :name="fieldKey"-->
    <!--                :options="field.options"-->
    <!--                :config="{id: 'id', label: 'label', multiple: true}"-->
    <!--                :label="getLabel"-->
    <!--                :value="dataValue">-->
    <!--  <template #label>{{ getLabel }}</template>-->
    <!--</editable-input>-->
    <editable-input v-else-if="fieldType === 'date'"
                    type="date"
                    :context="context"
                    :update="updater" :name="fieldKey"
                    :value="dataValue"
                    :label="getLabel">
    </editable-input>
    <editable-input v-else
                    type="textarea"
                    :context="context"
                    :update="updater" :name="fieldKey"
                    :value="dataValue"
                    :columnWidth="50">
    </editable-input>
    <!-- <editable-input v-else :context="context" :update="updater" :name="fieldKey" :value="dataValue"/> -->
  </div>
</template>

<script>
export default {
  props: {
    context: {
      default: () => {
      }
    },
    updater: {
      default() {
      }
    },
    field: {
      default: () => {
      }
    },
    data: {
      default: () => {
      }
    }
  },
  computed: {
    optSourceType() {
      return this.field.option_source_type
    },
    optionsCalced(){
      let _opts = []

      if(this.optSourceType && this.dataValue){
        if(this.dataValue){
          _opts = Array.isArray(this.dataValue) ? this.dataValueRaw : [{...this.dataValueRaw}]
        }
      }else{
        _opts = this.field.options
      }

      return _opts
    },
    fieldType() {
      return this.field.field_type
    },
    fieldKey() {
      return this.field.field_key
    },
    dataValueRaw(){
      return _.get(this.data, this.fieldKey)
    },
    dataValue() {
      let _value = _.get(this.data, this.fieldKey)

      if(['single_option', 'multiple_option'].includes(this.fieldType)
          && this.optSourceType
          && _value !== ''
          && _value != null){
        _value = Array.isArray(_value) ? _value.map(vl => vl.id) : _value.id
      }

      return _value
    },
    getLabel() {
      let label_ = ''
      switch (this.field.field_type) {
        case 'decimal_2':
          label_ = this.numberWithoutCurrencySignFormat(this.dataValue)
          break
        case 'date':
          label_ = this.momentMixin(this.dataValue)
          break
        case 'single_option':
          if(this.optSourceType){
            if(this.dataValueRaw !== '' && this.dataValueRaw != null){
              label_ = this.dataValueRaw.label
            }
          }else{
            label_ = _.get(this.optionsCalced.find(opt => opt.id == this.dataValue), 'label')
          }
          break
        case 'multiple_option':
          if(this.optSourceType){
            if(Array.isArray(this.dataValueRaw)){
              label_ = this.dataValueRaw.map(dvr => dvr.label).join(', ')
            }
          }else{
            const values_ = this.dataValue || []
            values_.forEach(dval => {
              const opt_ = this.optionsCalced.find(opt => opt.id == dval)
              if (opt_) {
                label_ += `${opt_.label} `
              }
            })
          }
          break
        default:
          label_ = this.dataValue
      }

      return label_
    },
    optionsConfig(){
      const multiple = this.fieldType === 'multiple_option'
      let extras = {}

      if(['single_option', 'multiple_option'].includes(this.fieldType)
          && this.optSourceType){
        extras.label = 'name'
        extras.ajax = {paginated: true, url: null, term: 'name'}

        if(['company'].includes(this.field.option_source)){
          extras.ajax.url = this.genUrl('companies', null,  'search')
        }
        if(['pe_vc'].includes(this.field.option_source)){
          extras.ajax.url = this.genUrl('companies', null,  'search')
          extras.ajax.params = {pe_only: 1}
        }
        else if(this.field.option_source === 'contact'){
          extras.ajax.term = 'query'
          extras.ajax.url = this.genUrl('contact', null,  'search')
        }
        else if(this.field.option_source === 'country'){
          extras.ajax.paginated = false
          extras.ajax.url = this.genUrl('companies', null,  'get_pe_country')
          extras.ajax.params = {wrap_in_data: 1}
        }
        else if(this.field.option_source === 'sector'){
          extras.label = 'title'
          extras.ajax.url = this.genUrl('sector')
        }
        else if(this.field.option_source === 'sub_sector'){
          extras.label = 'title'
          extras.ajax.url = this.genUrl('sub_sectors')
        }
        else if(this.field.option_source === 'user'){
          extras.ajax.term = 'query'
          extras.ajax.url = this.genUrl('users', null,  'search')
        }
      }

      return {id: 'id', label: 'label', multiple, ...extras}
    }
  },
}
</script>